import { Degree } from '@/models/Degree';
import { ISeoMetaDataInfo } from '../ISeoMetaDataInfo';
import { SeoMetaDataHandlerDefaultSort } from '../SeoMetaDataHandlerDefaultSort';

export class Default extends SeoMetaDataHandlerDefaultSort {
	protected canHandleWithDefaultSorting(): Promise<boolean> {
		return Promise.resolve(true);
	}

	protected async selfHandle(degree: Degree): Promise<ISeoMetaDataInfo> {
		const portalType = degree.toPortalName();

		const seoInfo = {
			title: `Complete list of universities from around the globe | ${portalType}`,

			description:
				`Explore our full list of universities from around the globe. ` +
				`Use our attendance, country and other filters to find your ideal university.`,
		};

		return Promise.resolve(seoInfo);
	}
}
